import { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import LineService from "../../../services/LineService";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
    md: {
      span: 9,
    },
    lg: {
      span: 10,
    },
    xl: {
      span: 10,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
    md: {
      span: 15,
    },
    lg: {
      span: 14,
    },
    xl: {
      span: 14,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
export default function InstitutionalLinesModalForm({
    isModalVisible,
    handleOk,
    handleCancel,
    lineTarget = null,
    CenterId,
  }) {
    const [form] = Form.useForm();
    const [formField, setformField] = useState(null);
  
    useEffect(() => {
      if (lineTarget) {
        setformField([
          { name: ["name"], value: lineTarget.name },
          { name: ["description"], value: lineTarget.description },

        ]);
      }
    }, [lineTarget]);
  
    const onFinish = (values) => {
      let lineR = { ...values };
      lineR={
        centerId: CenterId,
        ...lineR,
      }
      console.log("lineR",lineR)
      lineR.isInstitutional = true;
      //console.log("values", values);
      if (lineTarget) {
        lineR.id = lineTarget.id;
        console.log("lineRU",lineR)
        LineService.updateLine(lineTarget.id,lineR)
          .then((res) => {
            if (res.data?.success) {
              message.success("Línea actualizada.", 3);
              handleOk();
            } else {
              message.error(
                "No se pudo actualizar la Línea. " + res.data?.description,
                5
              );
            }
          })
          .catch((e) => {
            console.log("error", e.message);
            message.error("Hubo un error. " + e.message, 5);
          });
      } else {
        LineService.createLine(lineR)
          .then((res) => {
            if (res.data?.success) {
              message.success("Línea registrada.", 3);
              handleOk();
            } else {
              message.error(
                "No se pudo registar la Línea. " + res.data?.description,
                5
              );
            }
          })
          .catch((e) => {
            console.log("error", e.message);
            message.error("Hubo un error. " + e.message);
          });
      }
    };
    return (
      <Modal
        title="Registrar Línea"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        footer={null}
      >
        <Form
          className="form"
          {...formItemLayout}
          form={form}
          fields={formField}
          name="register"
          onFinish={onFinish}
          scrollToFirstError
        >
          <Form.Item
            name="name"
            label="Nombre de la Línea"
            rules={[
              {
                required: true,
                message: "Por favor ingresa el nombre de la Línea.",
                whitespace: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Descripción"
            rules={[
              {
                required: true,
                message: "Por favor ingresa la descripción de la Línea",
                whitespace: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Aceptar
            </Button>
            <Button
              type="secondary"
              htmlType="button"
              onClick={() => {
                handleCancel();
              }}
            >
              Cancelar
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
}
